let productNavigation;
(function() {
    const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
    const formattedLang = lang.replace('_', '-').toLowerCase();
    const overlayTriggered = false;

    window.onresize = function() {
        if ($('sub-element-box').length > 0) {
            resize();
        }
    };

    // same height for all systempartner-logos
    setHeightForSystemPartner();

    // enable fanybox for content images
    if ($('.fancybox').length > 0) {
        $('.fancybox').fancybox({
            padding: 5,
            afterLoad: function() {
                this.title = '<a class="download-link" href="' + this.href + '" download></a> ' + this.title;
            },
            helpers : {
                title: {
                    type: 'outside'
                }
            }
        });
    }

    if ($('.layout-100').length > 0) {
        window.onload = linkBlockPosition;
    }

    // same height for all figcaption
    function setHeightForFigcaption() {
       const el = $('.tx-filelist figcaption');
           if ($(el).length) {
               $(el).matchHeight();
               $(el).each((index, element) => {
                   $(element).css('min-height', `${$(element).height()}px`);
           });
       }
    }

    // Give all boxes in a row the height of the highest Box
    function resize() {
        const rows = $.fn.matchHeight._rows($('sub-element-box'));
        _.each(rows, (row) => {
            let highestBox;
            _.each(row, (box) => {
                $(box).height('');
                const boxHeight = $(box).height();
                if (!highestBox || highestBox > boxHeight) {
                    highestBox = boxHeight;
                }
            });
            $(row).find('sub-element-box').height(highestBox);
        });

        // same height for all systempartner-logos
        setHeightForSystemPartner();
    }

    // same height for all systempartner-logos
    function setHeightForSystemPartner() {
        const el = $('.ncsystempartner-entry');
        if ($(el).length) {
            $(el).matchHeight();
            $(el).each((index, element) => {
                $(element).css('line-height', `${$(element).height()}px`);
            });
        }
    }

    function linkBlockPosition() {
        const el = $('.layout-100');
        const elId = el.attr('id');
        const elParent = el.parent();

        if (elId && elId.match(/^(c{1})([0-9]+)/)) {
            el.addClass('flex-full-height');
        } else {
            elParent.addClass('flex-full-height');
        }
    }

    // see: https://github.com/jvandemo/angular-consent/issues/4
    let consentOptions = {
        path: '/',
        expires: getExpirationDate(),
    };

    consentOptions = JSON.stringify(consentOptions);

    function getExpirationDate() {
        let expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        expirationDate = expirationDate.toGMTString();
        return expirationDate;
    }

    $('#consent-node').attr('consent-cookie-options', consentOptions);


    function getLegacyLocaleFormat(locale) {
        const parts = locale.split('-');
        return `${parts[0]}_${parts[1].toUpperCase()}`;
    }

    async function loadAndMapLanguageFallbacks() {
        const locales = await $.ajax({
            url: `${globalConfig.services.languageService}api/Locale/getFallbacks`,
            cache: true,
        });

        const legacyFallbacks = {};
        locales.forEach((locale) => {
            legacyFallbacks[getLegacyLocaleFormat(locale.locale)] = locale.fallbacks
                .map(fallbackLocale => getLegacyLocaleFormat(fallbackLocale.locale)).join(', ');
        });
        return legacyFallbacks;
    }

    // @todo: move this process to the bootstrapping (note: this will always block our application
    //        from being booted fast without any form of caching).
    window.SBCStorage.setupSession(async () => {
        if (JSON.parse(sessionStorage.getItem("fallbacks"))) {
            globalConfig.languageFallbacks = JSON.parse(sessionStorage.getItem("fallbacks")).fallbacks
        }
        // globalConfig.languageFallbacks =  await loadAndMapLanguageFallbacks();
        if (JSON.parse(localStorage.getItem("webNavigation"))) {
            productNavigation = JSON.parse(localStorage.getItem("webNavigation")).webNavigation
        } 
        // productNavigation = await $.ajax({
        //     url: `${apiBaseUrl}webnavigation`,
        //     cache: false,
        //     headers: {
        //         'Accept-Language': `${lang}, ${globalConfig.languageFallbacks[lang]}`,
        //     }
        // });

        bootstrap();
    });



    // http://craigshoemaker.net/blog/recursively-sorting-javascript-arrays-lodash-underscore
    function customSortRecursive(array, propertyName) {
        array.forEach((item) => {
            const keys = _.keys(item);
            keys.forEach((key) => {
                if (_.isArray(item[key])) {
                    item[key] = customSortRecursive(item[key], propertyName);
                }
            });
        });

        return _.sortBy(array, propertyName);
    }

    function bootstrap() {
        // maybe its necessary to wrap a document ready condition,
        // if there are side effects caused by timing issues
        //angular.bootstrap(document, ['wwwSaiaPcd']);

        $('side-navigation-container').fadeIn('slow');
    }


    $(document).ready(() => {
        // ncgallery
        const galleryImages = $('.tx-filelist img');
        if (galleryImages.length > 0) {
            galleryImages.unveil(300);
            setHeightForFigcaption();
        }

        // Mobile navigation handling
        // Product navigation toggle
        const mobileNavigationToggle = $('.mobile-bars');
        const navigation = $('header nav');
        const menuArrwos = $('.menu-arrow');
        mobileNavigationToggle.click((e) => {
            mobileNavigationToggle.find('i').toggleClass('fa-remove fa-bars');
            navigation.stop(false, true).slideToggle();
        });

        menuArrwos.click((e) => {
            const targetElement = $(e.target);
            if (targetElement.parent().parent().attr('class').split(' ')
                .indexOf('top-level-navigation') != -1) {
                targetElement.siblings('.container').stop(false, true).slideToggle();
            } else {
                targetElement.siblings('ul').stop(false, true).slideToggle();
            }
            targetElement.toggleClass('rotate');
        });

        const productNavigationRoot = $('.product-navigation-root');
        const productNavigationRootContainer = productNavigationRoot.find('> div');
        const productNavigationRootLink = productNavigationRoot.find('> a');
        // hide and show navigation in case angular has hidden it on statechange
        productNavigationRoot.on('mouseenter', () => {
            productNavigationRootContainer.show();
        });

        productNavigationRoot.on('mouseleave', () => {
            productNavigationRootContainer.hide();
        });

        // Add thumbnails to youtube links
        const youtubeVideoButtons = $('.typo-youtube-video');
        const body = $('body');

        const dropContainers = document.getElementsByClassName('dropzone');
        if (dropContainers.length > 0) {
            Array.from(dropContainers).forEach((dropContainer) => {
                dropContainer.ondragover = dropContainer.ondragenter = function (e) {
                    e.preventDefault();
                };


                dropContainer.ondrop = function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const inputSelector = dropContainer.getAttribute('data-input-selector');
                    var fileInput = document.querySelector(`#${inputSelector}`);

                    fileInput.files = e.dataTransfer.files;
                };
            });
        }

        youtubeVideoButtons.each(function() {
            const target = $(this);
            const url = target.attr('href');
            const youtubeVideoId = url.split('/')[4];
            const thumbnailUrl = `https://img.youtube.com/vi/${youtubeVideoId}/0.jpg`;

            const caption = target.html();

            target.html(`
                <div class="ratio-container ratio-container--youtube">
                    <img src="${thumbnailUrl}" title="Youtube video thumbnail"/>
                </div>
                <span class="caption">${caption}</span>
                <span class="video" translate="cms.play.video">Video<span>
            `);
            // Youtube video modals
            target.click(function(e){
                e.preventDefault();

                const youtubeUrl = `${url}?autoplay=1&autohide=1&showinfo=0`;
                const modal = getModal(youtubeUrl);

                body.append(modal);

                modal.on('hidden.bs.modal', () => modal.remove());
                modal.modal('toggle');
            });
        });

        function getModal(youtubeUrl){
            return $(`
                <div id="modal-youtube" class="modal fade" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="ratio-container">
                                    <iframe src="${youtubeUrl}" frameborder="0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `);
        }

        // Scroll to form:
        //   When a powermail form was submitted
        //   scroll to the powermail form after
        //   the page has been loaded
        const scrollToTarget = $(".tx-powermail");
        const topOffset = 65;
        const urlString = location.href;
        const url = new URL(urlString);
        const powermailAction = url.searchParams.get("tx_powermail_pi1[action]");

        if (powermailAction === "create" || powermailAction === "confirmation") {
            if (scrollToTarget.length) {
                $("html,body").animate({
                    scrollTop: scrollToTarget.offset().top - topOffset
                },1000);
            }
        }
    });
}());

function adaptAlternativeSidepanelHeightAndPosition(isUpdate) {
    // elements.eq(0) = side-panel // elements.eq(1) = header image
    const elements = $('.header-image .item img, .alternative-sidepannel .side-panel');

    if (window.innerWidth > 1048) {
        if (elements.eq(1).length > 0) {
            if (isUpdate) {
                elements.matchHeight({
                    byRow: false,
                    target: elements.eq(1),
                });
            } else {
                elements.eq(1).on('load', () => {
                    elements.matchHeight({
                        byRow: false,
                        target: elements.eq(1),
                    });
                });
            }
        } else {
            elements.matchHeight({ remove: true });
            elements.eq(1).attr('height', 'auto');
        }

        $.fn.matchHeight._throttle = 40;
        $('.alternative-sidepannel').css('top', 0);

    } else {
        const spacer = $('.sidepanel-mobile-view-spacer');
        const offsetTopRefEl = $('.header-image').length > 0 ? $('.header-image') : spacer;

        if (isUpdate || elements.eq(1).height() > 0) {
            $('.alternative-sidepannel').css('top', spacer.offset().top);
        } else {
            $('.alternative-sidepannel').css('top', offsetTopRefEl.offset().top);
            elements.eq(1).load(() => {
                $('.alternative-sidepannel').css('top', spacer.offset().top);
            });
        }
        elements.eq(0).matchHeight({ remove: true });
        elements.eq(0).css('height', 'auto');
    }
}
